import { render, staticRenderFns } from "./AddCredentialsCard.vue?vue&type=template&id=23849797&scoped=true&"
import script from "./AddCredentialsCard.vue?vue&type=script&lang=js&"
export * from "./AddCredentialsCard.vue?vue&type=script&lang=js&"
import style0 from "./AddCredentialsCard.vue?vue&type=style&index=0&id=23849797&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23849797",
  null
  
)

export default component.exports